import { render, staticRenderFns } from "./personMgNew.vue?vue&type=template&id=758fb5de&scoped=true&"
import script from "./personMgNew.vue?vue&type=script&lang=js&"
export * from "./personMgNew.vue?vue&type=script&lang=js&"
import style0 from "./personMgNew.vue?vue&type=style&index=0&id=758fb5de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758fb5de",
  null
  
)

export default component.exports